import React, { useState } from "react";
import loader from "../assets/loader.webp";
import { ProFeatureModal, useIsPro } from "./ProGate";

// The Queue is a Pro-plan feature. Renders `children` for Pro stores and an
// upgrade notice (same pattern as Restock Pro) for everyone else.
// Only a plan that is known and not "pro" locks the Queue: if the profile has
// no plan info or fails to load we let it through (the API enforces the plan).

export function QueueProModal({ open, onClose, upgradePath }) {
  return (
    <ProFeatureModal
      open={open}
      onClose={onClose}
      upgradePath={upgradePath}
      title="Queue"
    >
      <p className="mt-3">
        Give each product a delivery time, then track every order until it is
        ready.
      </p>
      <ul className="mt-3 ml-5 list-disc text-gray-600 text-sm">
        <li>
          See a <span className="font-medium">live countdown</span> for every
          order
        </li>
        <li>
          <span className="font-medium">Extend</span> the delivery time when an
          order is delayed
        </li>
        <li>Know at a glance which orders are ready</li>
      </ul>
    </ProFeatureModal>
  );
}

function QueueProGate({ api, role, upgradePath, onClose, children }) {
  const { isLoading, locked } = useIsPro(api, role);
  const [showModal, setShowModal] = useState(true);

  if (isLoading) {
    return (
      <div className="w-full flex justify-center items-center py-16">
        <img src={loader} alt="loader" className="w-10 lg:w-20" />
      </div>
    );
  }
  if (!locked) return children;

  return (
    <div className="bg-white flex flex-col items-center justify-center py-16 px-8 text-center text-gray-500">
      <QueueProModal
        open={showModal}
        onClose={() => {
          setShowModal(false);
          if (onClose) onClose();
        }}
        upgradePath={upgradePath}
      />
      Queue is a Pro-plan feature.{" "}
      <button
        className="text-blue-700 font-semibold underline ml-1"
        onClick={() => setShowModal(true)}
      >
        Learn more
      </button>
    </div>
  );
}

export default QueueProGate;
